import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Avatar,
    TextField,
    Button,
    Chip,
    InputAdornment,
    IconButton,
    MenuItem,
    Select,
    FormControl,
    Grid,
    Card,
    CardContent,
    Rating,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate, useLocation } from "react-router-dom";
import { get } from "../../utility/fetch";
import Greeting from "../Layout/Greeting";

// const categories = ["General", "Dermato", "Physiologist", "Cardiologist"];

export default function CareGiverPage() {
    const [selectedCategory, setSelectedCategory] = useState(0);
    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [filteredData, setFilteredData] = React.useState([]);

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();

    const getHealthCareProvider = async () => {
        setIsLoading(true);
        console.log(query?.get("nn"))
        try {
            let response;
            if (query?.get("nn")) {
                response = await get(`/HealthCareProvider/list/HealthCareProviderCategory/${query?.get("nn")}/1/10`);
                console.log('Response:', response);
                setData(response?.resultList);
                setFilteredData(response?.resultList);
                setIsLoading(false);
            }
            else {
                response = await get(`/healthCareProvider/getAllHealthCareProviderList`);
                console.log('Response:', response);
                setData(response?.resultList);
                setFilteredData(response?.resultList);
                setIsLoading(false);
            }

        } catch (error) {
            console.error('Error fetching doctors:', error);
            setIsLoading(false);
        }
    }

    const getHealthCareProviderCategories = async () => {
        try {
            const response = await get(`/healthCareProvider/HealthCareProviderCategory/list`);
            console.log('Response:', response);
            setCategories(response?.data);
        } catch (error) {
            console.error('Error fetching doctors:', error);
        }
    }


    const handleChange = (cat) => {
        console.log(cat)
        setSelectedCategory(cat);
        const filtered = data.filter((doc) => doc?.healthCareProviderCategory?.id === cat?.id);
        setFilteredData(filtered);
    }

    useEffect(() => {
        getHealthCareProvider();
        getHealthCareProviderCategories();
    }, [])


    return (
        <Box sx={{ p: 2 }}>
            {/* Header */}
            <Greeting name={sessionStorage.getItem("name")} />


            {/* Title */}
            <Box mt={3} mb={2}>
                <Typography variant="h5" fontWeight="bold">
                    Search for {query?.get("nn") ? data[0]?.healthCareProviderCategory?.name : " Health Care Provider"}
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={1}>
                    {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, nulla a accumsan et. */}
                </Typography>
            </Box>

            <Button startIcon={<ArrowBackIosIcon />} onClick={() => navigate(-1)} sx={{ mb: 3 }}>
                Back
            </Button>

            {/* Filter Bar */}
            <Box mt={2}>
                <FormControl fullWidth>
                    <TextField
                        placeholder={`Search for a ${query?.get("nn")
                                ? data[0]?.healthCareProviderCategory?.name
                                : "Health Care Provider"
                            }`}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </FormControl>

                <Box display="flex" flexWrap="wrap" gap={1} mt={2}>
                    {!query?.get("nn") && categories?.filter(item => !(item?.id === 1 || item?.id === 3))?.map((cat) => (
                        <Chip
                            key={cat?.id}
                            label={cat?.name}
                            clickable
                            onClick={() => handleChange(cat)}


                            color={selectedCategory === cat ? "success" : "default"}
                            variant={selectedCategory === cat ? "filled" : "outlined"}
                        />
                    ))}
                </Box>
            </Box>

            {/* Doctor List */}
            <Box mt={3}>
                <Grid container spacing={2}>
                    {filteredData?.map((doc) => (
                        <Grid onClick={() => navigate(`/profile?cat=caregiver&id=${doc?.id}`)} sx={{ width: "100%", "&:hover": { cursor: "pointer", backgroundColor: "lightgreen" } }} item xs={12} key={doc.name}>
                            <Card sx={{ "&:hover": { backgroundColor: "lightgreen" } }} variant="outlined">
                                <CardContent sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <Box display="flex" gap={2}>
                                        {/* <Avatar src={process.env.REACT_APP_DOC_URL + doc.logoPath} sx={{ width: 56, height: 56 }} /> */}
                                        <Avatar src={doc.logoPath} sx={{ width: 56, height: 56 }} />
                                        <Box sx={{ cursor: "pointer" }}>
                                            <Typography fontWeight="bold">{`${doc?.name} `}</Typography>
                                            <Typography fontSize="14px" color="text.secondary">
                                                {doc?.workGrade}
                                            </Typography>
                                            <Typography>
                                                {doc?.location}
                                            </Typography>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <Rating value={Number(doc?.rating) || 0} precision={0.5} readOnly size="small" />
                                                <Typography fontSize="12px" color="text.secondary">
                                                    {doc?.rating}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <ArrowForwardIosIcon fontSize="small" />
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
}
